module.exports = __webpack_public_path__ + "assets/img/b880-sv.svg";